<template>
  <div id="app">
    <HeaderBar />

    <router-view />
    <BackToTop />
    <SiteFooter />
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar.vue'

import SiteFooter from './components/SiteFooter.vue'
import BackToTop from './components/BackToTop.vue'
import { findSeoForPath } from '@/services/requrest'

export default {
  name: 'App',
  components: {
    HeaderBar,

    BackToTop,
    SiteFooter
  },
  data() {
    return {
      currentSeo: {
        title: '',
        keyword: '',
        describe: ''
      },
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
    }
  },
  computed: {
    // ✅ 动态计算 header 高度
    headerHeight() {
      const width = this.windowWidth
      if (width <= 480) return 56  // 小屏手机
      if (width <= 768) return 64  // 手机
      return 70  // 桌面
    },
    // ✅ 判断是否手机端
    isMobile() {
      return this.windowWidth <= 768
    },
  },
  metaInfo() {
    const s = this.currentSeo || {}
    const title = s.title || '中泽教育'
    const desc = s.describe || ''
    const kw = s.keyword || ''
    const url = typeof window !== 'undefined' ? window.location.href : ''
    return {
      title,
      meta: [
        { name: 'keywords', content: kw },
        { name: 'description', content: desc },
        { property: 'og:title', content: title },
        { property: 'og:description', content: desc },
        { property: 'og:url', content: url },
        { property: 'og:type', content: 'website' }
      ]
    }
  },
  created() {
    this.updateSeo()
  },
  watch: {
    '$route.path': {
      handler() { this.updateSeo() },
      immediate: false
    }
  },
  methods: {
    async updateSeo() {
      try {
        const match = await findSeoForPath(this.$route && this.$route.path)
        if (match) {
          this.currentSeo = {
            title: match.title || '',
            keyword: match.keyword || '',
            describe: match.describe || ''
          }
        }
      } catch (e) {
        // 忽略错误，保持默认标题
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style>
/* ============================================
   全局基础样式
   ============================================ */
#app {
  font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  /* ✅ 动态 padding-top，由 JS 控制或使用 CSS 变量 */
  padding-top: 70px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}

/* ✅ 全局容器适配 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ✅ 手机端通用样式 */
@media (max-width: 768px) {
  #app {
    padding-top: 64px;
  }

  .container {
    padding: 0 16px;
  }

  /* ✅ 手机端字体微调 */
  body {
    font-size: 14px;
  }
}

/* ✅ 小屏手机 */
@media (max-width: 480px) {
  #app {
    padding-top: 56px;
  }

  .container {
    padding: 0 12px;
  }

  body {
    font-size: 13px;
  }
}

/* ✅ 平板端 */
@media (min-width: 769px) and (max-width: 1024px) {
  #app {
    padding-top: 70px;
  }

  .container {
    padding: 0 16px;
  }
}

/* ✅ 横屏手机 */
@media (max-width: 768px) and (orientation: landscape) {
  #app {
    padding-top: 56px;
  }
}

/* ============================================
   全局通用样式（可选）
   ============================================ */

/* ✅ 图片默认适配 */
img {
  max-width: 100%;
  height: auto;
}

/* ✅ 链接触摸优化 */
a, button {
  -webkit-tap-highlight-color: transparent;
}

/* ✅ 输入框手机端优化 */
input, textarea, select {
  font-size: 16px !important; /* 防止 iOS 自动缩放 */
  -webkit-appearance: none;
  appearance: none;
}

/* ✅ 全局过渡 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ✅ 暗黑模式适配（可选） */
@media (prefers-color-scheme: dark) {
  #app {
    background: #1a1a1a;
    color: #e8e8e8;
  }
}

/* ✅ 打印样式 */
@media print {
  #app {
    padding-top: 0;
  }
  .header-wrapper,
  .site-footer,
  .back-to-top {
    display: none !important;
  }
}
</style>